import { createStyledBreakpointsTheme } from 'styled-breakpoints'

import fonts from 'Theme/DefaultTheme/fonts'

import breakpoints from './breakpoints'
import button from './button'
import colors from './colors'
import zIndices from './zIndices'

const styledBreakpoints = createStyledBreakpointsTheme({
  // @ts-ignore
  breakpoints,
})?.breakpoints

const DEFAULT_THEME = {
  name: 'default',

  defaultTransitionTime: '0.3s',
  //0  1  2  3  4   5   6   7   8   9   10  11  12  13  14  15  16  17  18  19
  space: [
    0, 2, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 72, 80,
    //20  21
    88, 96,
  ],
  //          0   1   2   3   4   5   6   7   8   9
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72, 96],
  //             0    1
  fontWeights: [350, 500],
  //               0   1   2   3   4
  controlHeights: [24, 32, 40, 48, 56],

  breakpoints: Object.values(breakpoints),
  fonts,
  colors,
  zIndices,
  styledBreakpoints,
  button,
}

export default DEFAULT_THEME
